const CharUtils = {
  /**
   *
   * @param {array} rawData
   */
  formatDataForChart: function(rawData) {
    let categorias = [],
      valores = [];
    rawData.forEach(item => {
      categorias.push(item.periodo);
      valores.push(+item.valor);
    });
    return { categorias, valores };
  },
  /**
   * Prepara datos en el formato requerido por HighCharts
   *
   * @param {array} rawData
   * @returns {Object}
   */
  formatYearlyDataForChart: function(rawData) {
    let categorias = [],
      valores = [],
      anioInicio,
      anioFin,
      valorMinimo,
      valorMaximo;
    // Loop
    rawData.forEach(item => {
      categorias.push(item.periodo);
      valores.push(+item.valor);
    });
    // Calcular minimos y maximos
    anioInicio = categorias.length ? Math.min(...categorias) : null;
    anioFin = categorias.length ? Math.max(...categorias) : null;
    valorMinimo = valores.length ? Math.min(...valores) : null;
    valorMaximo = valores.length ? Math.max(...valores) : null;
    return {
      categorias,
      valores,
      anioInicio,
      anioFin,
      valorMinimo,
      valorMaximo
    };
  },
  /**
   *
   * @param {*} rawData
   */
  lastDataForChart: function(rawData) {
    let categorias = [],
      valores = [];
    rawData.forEach(item => {
      if (item.periodo) {
        categorias.push(item.periodo);
      }
      if (item.valor) {
        valores.push(+item.valor);
      }
    });
    return {
      LastValor: valores.length > 0 ? Math.max(...valores) : "",
      LastPeriodo: categorias.length > 0 ? Math.max(...categorias) : ""
    };
  },
  /**
   * Obtiene el mínimo valor de un array de valores
   * @param {array} values
   */
  getMinValue: function(values) {
    return Math.min(...values);
  },
  /**
   * Obtiene el máximo valor de un array de valores
   * @param {array} values
   */
  getMaxValue: function(values) {
    return Math.max(...values);
  }
};
export default CharUtils;
